import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import Switch from "react-switch";
import { GET, POST, PUT, DELETE, loading, alert, DateInput } from "../components/CustomComponent";

const AnnouncementModal = ({ show, onHide, editData, onSave }) => {
  const [isActive, setIsActive] = useState(true);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton className="bg-light border-0">
      <Modal.Title className="fw-bold h5 mb-0">
        {editData ? "แก้ไขประกาศ" : "สร้างประกาศใหม่"}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className="row g-3">
        <div className="col-md-12">
          <label className="form-label">หัวข้อประกาศ</label>
          <input type="text" className="form-control" defaultValue={editData?.topic || ""} placeholder="ระบุหัวข้อประกาศ..." />
        </div>
        <div className="col-md-6">
          <label className="form-label">เริ่มเผยแพร่</label>
          <DateInput className="form-control" defaultValue={editData?.startDate || ""} />
        </div>
        <div className="col-md-6">
          <label className="form-label">สิ้นสุด</label>
          <DateInput className="form-control" defaultValue={editData?.endDate || ""} />
        </div>
        <div className="col-md-12">
          <label className="form-label">กลุ่มเป้าหมาย</label>
          <select className="form-select" defaultValue={editData?.target || ""}>
            <option value="all">ทุกคนในบริษัท</option>
            <option value="it">เฉพาะแผนก IT</option>
          </select>
        </div>
        <div className="col-12">
          <label className="form-label">รายละเอียด</label>
          <textarea className="form-control" rows="4" placeholder="พิมพ์เนื้อหาประกาศ..."></textarea>
        </div>
        <div className="col-12">
          <label className="form-label mb-0 pointer" htmlFor="isActiveOvertime">เปิดใช้งาน (Active)</label><br/>
          <Switch checked={isActive} onChange={setIsActive} onColor="#0c75e6" height={24} width={48} id="isActiveOvertime" />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer className="bg-light border-0">
      <button type="button" className="btn btn-secondary" onClick={onHide}>บันทึกร่าง (Draft)</button>
      <button type="button" className="btn btn-primary" onClick={() => onSave({ isActive })}>เผยแพร่ทันที</button>
    </Modal.Footer>
  </Modal>
  );
};

export default function Announcements() {
  const { title, description } = appModules["announcements"];
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "ประกาศที่กำลังเผยแพร่", value: "3", color: "#0c76e5" },
    { label: "ฉบับร่าง", value: "1", color: "#e5a93e" },
    { label: "ประกาศหมดอายุ", value: "12", color: "#8a94a6" },
  ];

  const handleOpenModal = (data = null) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setShowModal(false);
  };

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/announcements", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid || editData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/announcements", body)
        : await PUT("v1/admin/announcements/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
        handleCloseModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/announcements/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <select className="form-select" style={{ width: '180px', borderRadius: '12px' }}>
            <option>กำลังเผยแพร่</option>
            <option>ทั้งหมด</option>
          </select>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
          + สร้างประกาศ
        </button>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h2 mb-0 fw-bold" style={{ color: item.color }}>{item.value}</h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">จัดการกระดานข่าวสาร</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">หัวข้อประกาศ</th>
                <th className="text-secondary fw-medium">เริ่มเผยแพร่</th>
                <th className="text-secondary fw-medium">สิ้นสุด</th>
                <th className="text-secondary fw-medium text-center rounded-end">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {['แจ้งวันหยุดสงกรานต์ประจำปี 2026', 'นโยบายการเบิกจ่ายสวัสดิการใหม่', 'กิจกรรม Townhall ประจำเดือน'].map((topic, i) => (
                <tr key={i}>
                  <td data-label="หัวข้อประกาศ"><div><div className="fw-medium">{topic}</div><div className="small text-secondary">ถึง: ทุกคนในบริษัท</div></div></td>
                  <td data-label="เริ่มเผยแพร่">1 เม.ย. 2026</td>
                  <td data-label="สิ้นสุด">18 เม.ย. 2026</td>
                  <td data-label="จัดการ" className="text-center">
                    <button onClick={() => handleOpenModal({ topic, startDate: "2026-04-01", endDate: "2026-04-18" })} className="btn btn-sm btn-outline-secondary rounded-3" title="แก้ไข"><i className="fa-solid fa-pen" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <AnnouncementModal show={showModal} onHide={handleCloseModal} editData={editData} onSave={CreateUpdate} />
    </AppShell>
  );
}